import TContext from "src/engine/context/TContext";
import { IPageModal } from "./Page";

export interface IPageContext {
    intent: any;
    pageName: string;
    registerBackListener: (callback: any) => void;
    pageBack: () => any;
    pageRef: () => any;
    stat: (info: any) => any;
    pageLast: boolean;
    moduleNum: any;
    showModal: (modalItem: IPageModal, args: any) => void;
}

const PageContext = new TContext<IPageContext>({
    intent: {},
    pageName: "",
    registerBackListener: (callback: any) => { },
    pageBack: () => {
        return false;
    },
    pageRef: () => { },
    showModal: (modalItem: IPageModal) => { },
    stat: (info: any) => { },
    pageLast: true,
    moduleNum: ""
});

export default PageContext;
